import SdsSportsSidebar from '@src/app/shared/modules/sportOffer/SdsSportsSidebar.vue';
import UserSelectionsContainer from '@modules/sportOffer/UserSelectionsContainer.vue';
import { SocialMobileSubnav } from '@app/mobile/subnavs';

import HomePage from './HomePage.vue';
import HomePageHeader from '@modules/home/HomePageHeader.vue';

export const homePage = {
    content: HomePage,
    leftSidebar: SdsSportsSidebar,
    subnav: HomePageHeader,
    rightSidebar: UserSelectionsContainer,
    mobileSubnav: SocialMobileSubnav,
    // mobile
    mobileBottomContent: UserSelectionsContainer,
};
